// @ts-nocheck
// material-ui
import { styled } from '@mui/material/styles';
import AppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';

// project import
import { DRAWER_WIDTH } from 'config';

// ==============================|| HEADER - APP BAR STYLED ||============================== //

interface Props extends MuiAppBarProps {
  open?: boolean;
}

// Same as front-end's AppBarStyled, without the Ask AI panel offset (no Ask AI here).
const AppBarStyled = styled(AppBar, { shouldForwardProp: (prop) => prop !== 'open' })<Props>(
  ({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 1,
    width: 'auto',
    left: open ? DRAWER_WIDTH : theme.spacing(7.5),
    right: 0,
    transition: `left ${open ? theme.transitions.duration.enteringScreen : theme.transitions.duration.leavingScreen}ms ${
      theme.transitions.easing.sharp
    }`
  })
);

export default AppBarStyled;
